import { AllInclusivePushLine } from 'Components/lines/all-inclusive-push-line/AllInclusivePushLine';
export default AllInclusivePushLine;
